module.exports = __webpack_public_path__ + "static/media/Zachary.662a20dd.jpg";